'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _pickBy2 = require('lodash/pickBy');

var _pickBy3 = _interopRequireDefault(_pickBy2);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _actions = require('../actions');

var _actions2 = _interopRequireDefault(_actions);

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)("App");
var headerHeight = (0, _jquery2.default)('.header__top').height() + (0, _jquery2.default)('.header__bottom').height();

var autoTabIndex = 2000; // start index for automatic indexing
var popUpTimeout = void 0;

window.linksoft.miniCartShow = function () {
    var $cartMenu = (0, _jquery2.default)('#cartMenu');

    $cartMenu.addClass('open');
};

window.linksoft.miniCartClose = function () {
    var $cartMenu = (0, _jquery2.default)('#cartMenu');

    $cartMenu.removeClass('open');
};

(0, _jquery2.default)(document).on('mouseleave', '#cartMenu', function (e) {
    popUpTimeout = setTimeout(function () {
        window.linksoft.miniCartClose();
    }, 1000);
});

function mapStateToProps(state, ownProps) {
    return {
        midCartVisibility: state.midCartVisibility
    };
}

var mapDispatchToProps = {
    updateMidCartVisibility: _actions2.default.updateMidCartVisibility
};

var AddToCart = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp = _class2 = function (_React$Component) {
    (0, _inherits3.default)(AddToCart, _React$Component);

    function AddToCart(props) {
        (0, _classCallCheck3.default)(this, AddToCart);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AddToCart.__proto__ || (0, _getPrototypeOf2.default)(AddToCart)).call(this, props));

        _this.wasSubmitted = false;

        _this.getFormClass = function () {
            var formClass = _this.props.formClass || '';
            if (_this.props.processing) {
                formClass += ' btn--pending';

                // let carousel box flipped
                _this.onProcessing(_this);
            }
            return formClass;
        };

        _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.onSubmit(e);
        };

        _this.tabIndex = props.tabIndex || autoTabIndex++;
        _this.inputId = 'addToCart_' + _this.tabIndex;
        _this.preorder = props.preorder || false;
        _this.onSubmit = props.onSubmit || function () {};
        _this.onProcessing = props.onProcessing || function () {};
        _this.onProcessingComplete = props.onProcessingComplete || function () {};
        _this.onSubmitComplete = props.onSubmitComplete || function () {};
        _this.isDisabled = props.isDisabled || false;

        _this.doneClass = '';
        return _this;
    }

    (0, _createClass3.default)(AddToCart, [{
        key: 'render',
        value: function render() {
            var _pickBy = (0, _pickBy3.default)(this.props),
                _pickBy$processing = _pickBy.processing,
                processing = _pickBy$processing === undefined ? false : _pickBy$processing;

            var formClass = this.getFormClass() + ' ' + this.doneClass;

            if (processing) {
                this.wasSubmitted = true;
            }

            if (!processing && !this.wasSubmitted) {
                this.wasSubmitted = false;
                this.onProcessingComplete(this);
            }

            var css = 'btn btn--green' + (this.isDisabled ? ' disabled' : '');
            var buttonSubmit = this.isDisabled ? function () {
                return false;
            } : this.handleSubmit;

            return _react2.default.createElement(
                'form',
                { className: 'add-to-cart' },
                _react2.default.createElement(
                    'a',
                    { onClick: buttonSubmit, className: css + ' ' + formClass },
                    _react2.default.createElement('i', { className: 'icon--cart' }),
                    _react2.default.createElement(
                        'span',
                        { className: 'into-cart-text' },
                        Resx.App.IntoCart
                    )
                )
            );
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProp) {
            var _this2 = this;

            // condition for item added cart, but not in pageload
            if (this.props.processing && !nextProp.processing) {
                var self = this;
                self.doneClass = 'btn--success';
                this.onSubmitComplete(this);

                setTimeout(function () {
                    _this2.props.updateMidCartVisibility(true);
                }, 400);

                setTimeout(function () {
                    // cannot do by reactjs way so I do like this...
                    (0, _jquery2.default)(document).find('.btn--success').removeClass('btn--success');
                    self.doneClass = '';
                }, 4000);
            }
        }
    }]);
    return AddToCart;
}(_react2.default.Component), _class2.propTypes = {
    productId: _propTypes2.default.number,
    processing: _propTypes2.default.bool.isRequired,
    midCartVisibility: _propTypes2.default.bool,
    updateMidCartVisibility: _propTypes2.default.func
}, _temp)) || _class);
exports.default = AddToCart;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/add-to-cart.js
// module id = 563
// module chunks = 0 2